module.exports = __webpack_public_path__ + "static/toast-actionbuttons-do-46a74f92c7c27ee60b254fb7eb16df58.png";